
import { DatePicker, Modal, Pagination, Tooltip, Drawer, Select } from "antd";
import { VideoCameraOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import React, { useEffect,useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type';
import { fetch_patients_details, fetch_interbranch_appointment_history } from "../../actions/InterBranchCoordinatorAction"
import Spinner from "react-bootstrap/Spinner";
import './appointmenthistory.css'
import ConsultationHistorydatePicker from '../ConsultationHistorydatePicker/ConsultationHistorydatePicker';
import { fetchSelectedAppointmentDetails } from '../../actions/AppointmentActions';
import CustomeModal from "../CustomeModal/CustomeModal";
import AppointmentHistoryModalContent from "../AppoinmentHistory/AppointmentHistoryModalContent/AppointmentHistoryModalContent";
const { RangePicker } = DatePicker;

function InterBranchAppointmentHistory() {

    const dispatch = useDispatch()
    let history = useHistory()
    let reduxData = useSelector(state => state);
    let [modal, setModal] = useState(false);
    let [totalnoofpages, setTotalnoofpages] = useState(0);
    let [totalCount, setTotalCount] = useState(0);
    let [activePage, setActivePage] = useState(1);
    let [loader, setLoader] = useState(true);
    const PAGE_SIZE = 10; // Items per page
    
    // console.log("Redux Data in InterBranchAppointmentHistory: ", reduxData)
    const userData = useSelector(
        (state) => state.login.user
    );
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails?.profileId;
    // console.log("Co-ordinator Id: ", userId)
    //let appointmentHistory = reduxData?.interBranchCoordinator?.interBranchAppointmentHistory;
    let [appointmentHistory, setAppointmentHistory] = useState([]);
    console.log("Appointment History: ", appointmentHistory)

    useEffect(() => {
        if (!userId) return;
        
        try {
            setLoader(true);
            dispatch(
                fetch_interbranch_appointment_history(userId, { date: new Date().toString() }, 0)
            ).then((res) => {
                console.info("Response", res);
                if (res) {
                    setTotalnoofpages(res?.totalNumberOfPages || 0);
                    // Use totalCount if available, otherwise calculate from pages
                    const total = res?.totalCount || (res?.totalNumberOfPages || 0) * PAGE_SIZE;
                    setTotalCount(total);
                    // Handle both property names for backward compatibility
                    setAppointmentHistory(res?.appointmentlist || res?.appointmentHistory || []);
                }
                setLoader(false);
            }).catch((error) => {
                console.log("Error in fetch_interbranch_appointment_history API", error);
                setLoader(false);
            });

            //Fetching the appointment history of the Co-ordinator (IMPORTANT -93579795 - for testing)
            
        } catch (error) {
            console.log("Error in fetch_interbranch_appointment_history API", error);
            setLoader(false);
        }
    }, [dispatch, userId])


    let handleTableClick = (appointmentId) => {
        // console.log("Selected Apt Id ",appointmentId);
        // console.log("User Details:",userDetails)
        // console.log("User Data:",userData)
        dispatch(fetchSelectedAppointmentDetails({
            appointmentId: appointmentId ? appointmentId : null,
            userData
        }));

        dispatch({
            type: INTERBRANCH_MODAL_UPDATE,
            payload: { modalName: "consultationHistory", isVisible: true, data: { name: "name" } }
        })
        setModal(true);

    }

    let handleRangePicker = (range, dates) => {

        console.log(range, dates);
    }

    let handlePaginationChange = (page) => {
        setActivePage(page);
        setLoader(true);
        
        // Convert 1-indexed page to 0-indexed offset
        const offset = (page - 1);
        
        dispatch(fetch_interbranch_appointment_history(userId, { date: new Date().toString() }, offset)).then(
          (res) => {
            console.log(
              "**************fetchAppointmentHistory API result ==> ",
              res
            );
            if (res) {
                setTotalnoofpages(res?.totalNumberOfPages || 0);
                // Use totalCount if available, otherwise calculate from pages
                const total = res?.totalCount || (res?.totalNumberOfPages || 0) * PAGE_SIZE;
                setTotalCount(total);
                // Handle both property names for backward compatibility
                setAppointmentHistory(res?.appointmentlist || res?.appointmentHistory || []);
            }
            setLoader(false);
          }
        ).catch((error) => {
            console.log("Error in pagination API call", error);
            setLoader(false);
        });
      };


    let handleDateBlockClick = (e) => {


        // console.log(e);
        // try {
        //     //Fetching the appointment history of the Co-ordinator (IMPORTANT -93579795 - for testing)
        //     dispatch(fetch_interbranch_appointment_history(userId,{date:new Date().toString()}));
        // } catch (error) {
        //     console.log("Error in fetch_interbranch_appointment_history API", error);
        // }
    }


    // Helper function to get consultation mode icon
    const getConsultationModeIcon = (appointment) => {
        const mode = appointment?.modeOfConsultation ;
        console.info("appointment",mode);
        
        const modeLower = mode.toLowerCase();
        
        if (modeLower.includes("video") || modeLower === "video") {
             return "Scheduled"
        } else if (modeLower.includes("audio") || modeLower.includes("phone") || modeLower === "audio" || modeLower === "phone") {
             return "Scheduled"
        } else if (modeLower.includes("in-person") || modeLower.includes("offline") || modeLower.includes("interbranch") || modeLower === "offline") {
            return "Walk In"
        } else {
            // Default to video if mode is not specified
             return "Scheduled"
        }
    };

    console.info("appointmentHistory",appointmentHistory)
    return (
        <>
        <div className='appontment-history-container'>    

            {
                loader  ? (                
                <div className='loader'
                style={{
                    width:"100%",
                    display:"flex",
                    flexDirection:"row",
                    alignItems:"center",
                    justifyContent:"center",
                    // marginTop:"15px"
                }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>):
                appointmentHistory != null ?

                    <table className='appoinment-table'>
                        <thead>
                            <tr>
                                <th>Appointment ID (mode)</th>
                                <th>Date/Time</th>
                                <th>Doctor Name</th>
                                <th>Patient Name</th>
                               
                                <th>Consultation Status</th>
                                {/* <th>Next Steps</th> */}
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                // appointmentHistory == undefined ? (
                                //     <div className='loader'>
                                //         <Spinner animation="border" role="status">
                                //             <span className="visually-hidden">Loading...</span>
                                //         </Spinner>
                                //     </div>) :

                                appointmentHistory != null && appointmentHistory.length > 0 ?
                                    appointmentHistory?.map((element, key) => {
                                        const modeInfo = getConsultationModeIcon(element);
                                        return (
                                            <tr key={key || element.appointmentId}>
                                                <td >{element.appointmentId} - {modeInfo}
                                                   
                                                </td>
                                                <td >{element.appointmentDate}</td>
                                                <td>{element.doctorName}</td>
                                                <td >{element.consultantName}</td>
                                               
                                                <td >
                                                    {element.appointmentStatus==="C"?"Completed":element.appointmentStatus}
                                                    {element.status==="On-going" &&
                                                    <>
                                                    <br/>
                                                     <button
                        className="join-btn"
                        type={"button" }
                        onClick={() => {
                            
                            history.push("/meetspoke/"+element.appointmentId);
                           // handleTableClick(element.appointmentId) 
                        
                        }} 
                       //onClick={handleClick}
                      >
                        JOIN NOW
                      </button>
                      </>
                                                    }
                                                </td>
                                                {/* <td >
                                             Not Available
                                         </td> */}
                                                <td  ><button onClick={() => { handleTableClick(element.appointmentId) }} className='more-btn' >More</button></td>

                                            </tr>
                                        )
                                    })
                                    :
                                    ""



                            }
                        </tbody>
                    </table>

                    : <div className="no-appointments">Oops!! There is no appointments available for you.</div>
            }

 

            {totalnoofpages > 0 && (
                <div className="pagination-container">
                    <Pagination
                        showSizeChanger={false}
                        onChange={handlePaginationChange}
                        current={activePage}
                        total={totalCount || totalnoofpages * PAGE_SIZE}
                        pageSize={PAGE_SIZE}
                       // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    />
                </div>
            )}

        </div>

         <CustomeModal
            state={modal}
            setModal={setModal}
            component={<AppointmentHistoryModalContent />}
            isRight
        />
      </>
    )
}

export default InterBranchAppointmentHistory